import {
  AppBar,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Collapse,
  colors,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Pagination,
  Skeleton,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Header from "components/Header";
import BG from "assets/images/BG.png";
import Contact from "components/Contact";
import {
  ArrowBackIos,
  ArrowBackIosNew,
  ArrowForwardIos,
  ChevronLeft,
  ChevronRight,
  DirectionsCar,
  ExpandLess,
  ExpandMore,
  MapsHomeWork,
  NorthEast,
  Search,
  ShoppingBag,
  Sort,
  Whatshot,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import CustomPagination from "components/TableExplanded/Pagination";
import ModalProduct from "components/Modal/MarketPlace/ModalProduct";
import { GradientCircularProgress } from "components/Loading";
import api from "_api";
import { useNavigate, useSearchParams } from "react-router-dom";
import { formatCurrency2Digit } from "utils/helpers/format";

const useStyles = makeStyles((theme) => ({
  cardProducts: {
    borderRadius: "25px",
    width: "100%",
    height: "100%",
    border: "1px solid #e0e0e0",
    boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.25)",
  },
}));

const defaultArrowStyle = {
  color: "white", // สีของไอคอนลูกศร
  backgroundColor: "rgba(0, 0, 0, 0.5)", // สีพื้นหลังของไอคอน
  height: "40px", // ความสูงของไอคอน
  fontSize: "1.5rem", // ขนาดของไอคอน
  position: "absolute",
  zIndex: 10,
  cursor: "pointer",
  "&:hover": {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

const CustomNextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <ArrowForwardIos
      className={className}
      onClick={onClick}
      sx={{
        ...defaultArrowStyle,
        right: "-10px", // ตำแหน่งแนวนอน
      }}
    />
  );
};

const CustomPrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <ArrowBackIosNew
      className={className}
      onClick={onClick}
      sx={{
        ...defaultArrowStyle,
        left: "-10px", // ตำแหน่งแนวนอน
      }}
    />
  );
};

const PriceFormatter = ({ price }) => {
  if (!price && price !== 0) return null;
  return (
    <Typography
      sx={{
        fontSize: "18px",
        fontWeight: "medium",
        color: "#00bb9f",
      }}
    >
      {price >= 1000000
        ? `${(price / 1000000).toFixed(price % 1000000 > 0 ? 1 : 0)} ลบ`
        : `${formatCurrency2Digit(price)} บ`}
    </Typography>
  );
};

const DEFAULTMENUS = [
  {
    title: "สินค้า",
    segment: "product",
    icon: <ShoppingBag />,
    children: [
      { label: "เครื่องประดับ", id: 1 },
      { label: "อิเล็กทรอนิกส์", id: 2 },
      { label: "ทองคำ", id: 3 },
      { label: "พระเครื่อง", id: 4 },
      { label: "แบรนด์เนม", id: 5 },
      { label: "นาฬิกา", id: 6 },
    ],
  },
  {
    title: "รถ",
    segment: "car",
    icon: <DirectionsCar />,
    children: [
      {
        label: "รถยนต์",
        id: "รถยนต์",
      },
      {
        label: "รถมอเตอร์ไซต์",
        id: "มอเตอร์ไซต์",
      },
    ],
  },
  // {
  //   title: "อสังหาริมทรัพย์",
  //   segment: "house",
  //   icon: <MapsHomeWork />,
  //   children: [
  //     {
  //       label: "ที่ดิน",
  //       id: "land",
  //     },
  //     {
  //       label: "คอนโด",
  //       id: "condo",
  //     },
  //     {
  //       label: "บ้านเดี่ยว",
  //       id: "house",
  //     },
  //     {
  //       label: "ตึกแถวอาคารพาณิชย์",
  //       id: "shophouse",
  //     },
  //     {
  //       label: "อาคารสำนักงาน",
  //       id: "office",
  //     },
  //     {
  //       label: "โฮมออฟฟิศ",
  //       id: "homeoffice",
  //     },
  //     {
  //       label: "โรงงาน/โกดัง/คลังสินค้า",
  //       id: "factory",
  //     },
  //     {
  //       label: "ร้านค้า/ร้านอาหาร",
  //       id: "shop",
  //     },
  //     {
  //       label: "โชว์รูม/สำนักงานขาย",
  //       id: "showroom",
  //     },
  //     {
  //       label: "กิจการ/โรงแรม/หอพัก",
  //       id: "hotel",
  //     },
  //   ],
  // },
];

function MarketPlace() {
  const classes = useStyles();
  const [openSubMenu, setOpenSubMenu] = useState([]);
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [lastestProducts, setLastestProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const product_type = searchParams.get("product");

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState({
    search: "",
    category_id: [],
    car_type: [],
    sortBy: "",
  });

  const [paginate, setPaginate] = useState({
    page: 1,
    limit: 10,
    totalItems: 0,
    totalPages: 1,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [activeSlide, setActiveSlide] = useState(0);

  const [isLoading, setIsLoading] = useState(true);

  const [showSlider, setShowSlider] = useState(false);

  const isXL = useMediaQuery("(min-width:1500px)"); // แสดงได้ 5 ชิ้น
  const isLG = useMediaQuery("(min-width:1200px)");
  const isMD = useMediaQuery("(min-width:992px)");
  const isSM = useMediaQuery("(min-width:768px)");

  const getMaxVisible = () => {
    if (isXL) return 5;
    if (isLG) return 4;
    if (isMD) return 3;
    if (isSM) return 2;
    return 1; // จอเล็ก
  };

  useEffect(() => {
    const visible = getMaxVisible();
    setShowSlider(recommendedProducts.length > visible);
  }, [isXL, isLG, isMD, isSM, recommendedProducts]);

  useEffect(() => {
    if (product_type !== null) {
      fetchDataListForType(product_type);
    } else {
      fetchData();
    }
  }, [paginate.page, paginate.limit, filter, product_type]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await api.marketplace.getMarketplaceData({
        ...filter,
        search: search,
        page: paginate.page,
        limit: paginate.limit,
      });
      if (response.isStatus) {
        const { all, popular, latest } = response.data;
        setProducts(all?.items || []);
        setRecommendedProducts(popular?.items || []);
        setLastestProducts(latest?.items || []);
        setPaginate({
          ...paginate,
          page: all?.pagination?.page || 1,
          limit: all?.pagination?.limit || 10,
          totalItems: all?.pagination?.totalItems || 0,
          totalPages: all?.pagination?.totalPages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDataListForType = async (type) => {
    setIsLoading(true);
    try {
      const response = await api.marketplace.getMarketplaceList(type, {
        ...filter,
        search: search,
        page: paginate.page,
        limit: paginate.limit,
      });
      if (response.isStatus) {
        const { items, pagination } = response.data;
        setProducts(items || []);
        setPaginate({
          ...paginate,
          page: pagination?.page || 1,
          limit: pagination?.limit || 10,
          totalItems: pagination?.totalItems || 0,
          totalPages: pagination?.totalPages || 1,
        });
      } else {
        throw new Error("Failed to fetch products");
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    arrows: true,
    beforeChange: (current, next) => {
      const pageIndex = Math.floor(next / 5); // 5 = slidesToScroll
      setActiveSlide(pageIndex);
    },
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          beforeChange: (current, next) => {
            const pageIndex = Math.floor(next / 4);
            setActiveSlide(pageIndex);
          },
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          beforeChange: (current, next) => {
            const pageIndex = Math.floor(next / 3);
            setActiveSlide(pageIndex);
          },
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          beforeChange: (current, next) => {
            const pageIndex = Math.floor(next / 2);
            setActiveSlide(pageIndex);
          },
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          beforeChange: (current, next) => {
            const pageIndex = Math.floor(next / 1);
            setActiveSlide(pageIndex);
          },
        },
      },
    ],
    customPaging: (i) => (
      <Box
        sx={{
          width: "30px",
          height: "10px",
          backgroundColor: activeSlide === i ? "#00bb9f" : "rgba(0, 0, 0, 0.2)",
          borderRadius: "16px",
          transition: "all 0.3s ease",
        }}
      />
    ),
    appendDots: (dots) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          gap: 1,
        }}
      >
        {dots}
      </Box>
    ),
  };

  const handleSubMenuClick = (index) => {
    setOpenSubMenu((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const handleModal = () => {
    setOpenModal(!openModal);
  };

  const handleAllProduct = (type) => {
    setPaginate({ ...paginate, page: 1, limit: 10 });
    navigate(`/marketplace?product=${type}`);
  };

  const handlePageChange = (event, newValue) => {
    setPaginate({ ...paginate, page: newValue + 1 });
  };

  const handleRowsPerPageChange = (e) => {
    setPaginate({
      ...paginate,
      limit: parseInt(e.target.value, 10),
      page: 1,
    });
  };

  const renderProductCard = (product, index) => {
    const { Product, car, max_price } = product;
    console.log({
      Product,
      car,
      max_price,
    });

    return (
      <>
        <Card className={classes.cardProducts}>
          <CardMedia
            component="img"
            image={Product?.image || car?.image || "/images/placeholder.png"}
            alt={Product?.product_name ?? car?.car_name ?? "Product Image"}
            height={250}
            sx={{
              borderRadius: "25px",
              padding: "8px",
            }}
          />
          <CardContent
            sx={{
              width: "100%",
              padding: 1,
              height: "auto",
              "&:last-child": { paddingBottom: 1 },
            }}
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "medium",
                color: "#212529",
              }}
              noWrap
            >
              {Product?.product_name || car?.car_name}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "Regular",
                color: "#6c6c6c",
              }}
            >
              {product.type}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <PriceFormatter
                price={
                  product?.max_price ||
                  Product?.price ||
                  car?.sell_price ||
                  car?.car_price ||
                  0
                }
              />
              <Button
                className="button-two-tone"
                variant="contained"
                sx={{
                  width: "auto",
                  borderRadius: "12px",
                }}
                onClick={() => {
                  setSelectedProduct(product);
                  handleModal();
                }}
              >
                เพิ่มเติม
              </Button>
            </Box>
          </CardContent>
        </Card>
      </>
    );
  };

  return (
    <>
      <Header />
      {/* title */}
      <Box
        sx={{
          position: "relative",
          backgroundImage: `url(${BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "300px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: "76px",
        }}
      >
        <Typography variant="h3">MarketPlace</Typography>
        <Typography variant="h5">สินค้าที่อยู่ในระบบ</Typography>
      </Box>
      {/* search bar */}
      <Box
        sx={{
          position: "sticky",
          top: "76px", // To ensure it doesn't overlap with the header
          backgroundColor: "#fff",
          zIndex: 1200, // Ensures search bar stays below the header
        }}
      >
        <AppBar
          sx={{
            backgroundColor: "#bfeee7",
            boxShadow: "none",
            height: "86px",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            zIndex: 1200,
          }}
          position="sticky"
        >
          <TextField
            hiddenLabel
            placeholder="ค้นหา"
            variant="outlined"
            sx={{
              width: "1000px",
              backgroundColor: "white",
              borderRadius: "12px",
              border: "0px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "54px",
                border: "0px",
              },
              "& fieldset": {
                border: "none", // default Textfield
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchData();
              }
              //ถ้าโดนลบจนหมด ให้รีเฟรชข้อมูล
              if (e.key === "Backspace" && e.target.value === "") {
                fetchData();
              }
            }}
          />
          <Button
            id="sort_by_price"
            variant="contained"
            sx={{
              backgroundColor: "white",
              color: "#00bb9f",
              borderRadius: "12px",
              width: "auto",
              height: "50px",
              ml: 2,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "white",
                boxShadow: "none",
              },
            }}
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <Sort />
          </Button>
          <Menu
            id="sort_by_price"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            sx={{
              "& .MuiMenu-paper": {
                borderRadius: "12px",
                "& .MuiMenuItem-root": {
                  height: "30px",
                },
              },
            }}
          >
            <MenuItem
              onClick={() => {
                setFilter({ ...filter, sort: "price_desc" });
                handleClose();
              }}
            >
              ราคา สูง - ต่ำ
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem
              onClick={() => {
                setFilter({ ...filter, sort: "price_asc" });
                handleClose();
              }}
            >
              ราคา ต่ำ - สูง
            </MenuItem>
          </Menu>
        </AppBar>
      </Box>
      <Box className="bg-white">
        <Grid container spacing={2}>
          {/* Sidebar */}
          <Grid
            size={4}
            sx={{
              width: "20%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                position: "sticky",
                top: "162px",
                mt: 2,
              }}
            >
              <List
                sx={{ width: "100%", maxWidth: "100%", ml: 2 }}
                component="nav"
              >
                {DEFAULTMENUS.map((item, index) => (
                  <>
                    <ListItem
                      key={index}
                      onClick={() => handleSubMenuClick(index)}
                    >
                      <ListItemButton
                        sx={{
                          borderLeft: openSubMenu[index]
                            ? "4px solid #00bb9f"
                            : "",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            color: "#00bb9f",
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            fontSize: "16px",
                            fontWeight: "SemiBold",
                            fontFamily: "prompt",
                            color: openSubMenu[index] ? "#00bb9f" : "#737373",
                          }}
                          primary={item.title}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: colors.grey[100],
                            borderRadius: "50%",
                            color: "#737373",
                          }}
                        >
                          {openSubMenu[index] ? <ExpandLess /> : <ExpandMore />}
                        </Box>
                      </ListItemButton>
                    </ListItem>
                    <Collapse
                      in={openSubMenu[index]}
                      timeout="auto"
                      unmountOnExit
                      sx={{
                        mx: 4,
                      }}
                    >
                      <List
                        component="div"
                        disablePadding
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "12px",
                          "& .MuiListItem-root": {
                            "&:hover": {
                              "& .MuiCheckbox-root, & .MuiTypography-root": {
                                color: "#00bb9f",
                              },
                            },
                          },
                        }}
                      >
                        {item.children.map((child, childIndex) => (
                          <ListItem key={childIndex} disablePadding>
                            <ListItemButton
                              onClick={() => {
                                if (item.segment === "car") {
                                  if (filter.car_type.includes(child.id)) {
                                    setFilter({
                                      ...filter,
                                      car_type: filter.car_type.filter(
                                        (type) => type !== child.id
                                      ),
                                    });
                                  } else {
                                    setFilter({
                                      ...filter,
                                      car_type: [...filter.car_type, child.id],
                                    });
                                  }
                                } else {
                                  if (filter.category_id.includes(child.id)) {
                                    setFilter({
                                      ...filter,
                                      category_id: filter.category_id.filter(
                                        (type) => type !== child.id
                                      ),
                                    });
                                  } else {
                                    setFilter({
                                      ...filter,
                                      category_id: [
                                        ...filter.category_id,
                                        child.id,
                                      ],
                                    });
                                  }
                                }
                              }}
                            >
                              <ListItemIcon>
                                <Checkbox
                                  id={index + "-checkbox-" + childIndex}
                                  sx={{
                                    "&.Mui-checked": {
                                      color: "#00bb9f",
                                    },
                                  }}
                                  checked={
                                    item.segment === "car"
                                      ? filter.car_type.includes(child.id)
                                      : filter.category_id.includes(child.id)
                                  }
                                />
                              </ListItemIcon>
                              <ListItemText
                                sx={{
                                  fontSize: "14px",
                                }}
                                primary={child.label}
                              />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </>
                ))}
              </List>
            </Box>
          </Grid>
          {/* Content */}
          <Grid
            size={8}
            sx={{
              width: "80%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                }}
              >
                <GradientCircularProgress size={80} />
              </Box>
            ) : product_type !== null ? (
              <Box
                sx={{
                  padding: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "100%",
                    mt: 2,
                    gap: 2,
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontSize: "32px" }}>
                      {product_type === "popular"
                        ? "สินค้ายอดฮิต"
                        : product_type === "latest"
                        ? "สินค้าล่าสุด"
                        : "สินค้าทั้งหมด"}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        navigate({
                          pathname: "/marketplace",
                        });
                        setPaginate({ ...paginate, page: 1, limit: 10 });
                        setFilter({
                          search: "",
                          category_id: [],
                          car_type: [],
                          sortBy: "",
                        });
                        setSearch("");
                      }}
                    >
                      <ChevronLeft
                        sx={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                      <Typography
                        sx={{
                          fontWeight: "Regular",
                          fontSize: "20px",
                        }}
                      >
                        ย้อนกลับ
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      padding: 1,
                      width: "100%",
                    }}
                  >
                    <Grid container spacing={2}>
                      {products.slice(0, 15).map((product, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                          {renderProductCard(product, index)}
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                  <CustomPagination
                    totalPage={paginate.totalPages}
                    page={paginate.page - 1}
                    onPageChange={handlePageChange}
                    rowsPerPage={paginate.limit}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  padding: 2,
                }}
              >
                {/* Recommended or Hot Products */}
                {recommendedProducts?.length > 0 && (
                  <Box
                    sx={{
                      mt: 2,
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      background:
                        "linear-gradient(to right, rgba(76, 184, 186, 0.1), rgba(123, 216, 103, 0.1))",
                      width: "100%",
                      gap: 2,
                      borderRadius: "8px",
                      padding: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography sx={{ fontSize: "32px" }}>
                        สินค้ายอดฮิต
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => handleAllProduct("popular")}
                      >
                        <Typography
                          sx={{
                            fontWeight: "Regular",
                            fontSize: "20px",
                          }}
                        >
                          ดูทั้งหมด
                        </Typography>
                        <ChevronRight
                          sx={{
                            width: "24px",
                            height: "24px",
                          }}
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      {showSlider ? (
                        <Slider {...settings}>
                          {recommendedProducts?.map((product, index) => {
                            const { Product, car } = product;
                            return (
                              <Box
                                key={index}
                                sx={{
                                  width: { xs: "100%", sm: 274 }, // กว้างเต็มที่ในหน้าจอเล็ก
                                  height: { xs: "auto", sm: 280 }, // ปรับความสูง
                                  padding: 1,
                                }}
                              >
                                <Card
                                  className={classes.cardProducts}
                                  sx={{
                                    position: "relative",
                                  }}
                                >
                                  <CardMedia
                                    component="img"
                                    image={Product?.image || car?.image || ""}
                                    alt={Product?.product_name || car?.car_name}
                                    height={200}
                                    sx={{
                                      borderRadius: "22px",
                                      objectFit: "cover",
                                      px: "3px",
                                      pt: "3px",
                                    }}
                                  />
                                  <CardContent
                                    sx={{
                                      width: "100%",
                                      height: "auto",
                                      padding: 1,
                                      // "&:last-child": { paddingBottom: 1 },
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flexDirection: "row",
                                        px: 1,
                                        paddingBottom: 1,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          width: "70%",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: "prompt",
                                            fontSize: "18px",
                                            fontWeight: "medium",
                                            color: "#212529",
                                          }}
                                          noWrap
                                        >
                                          {Product?.product_name ||
                                            car?.car_name}
                                        </Typography>
                                        <PriceFormatter
                                          price={
                                            Product?.price ||
                                            car?.sell_price ||
                                            car?.car_price ||
                                            0
                                          }
                                        />
                                      </Box>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "2px solid #ccc",
                                          borderRadius: "50%",
                                          height: "45px",
                                          width: "45px",
                                          cursor: "pointer",
                                          paddingBottom: 1,
                                        }}
                                        onClick={() => {
                                          setSelectedProduct(product);
                                          handleModal();
                                        }}
                                      >
                                        <NorthEast
                                          sx={{
                                            width: "20px",
                                            height: "20px",
                                            color: "#00bb9f",
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  </CardContent>
                                  <Badge
                                    sx={{
                                      position: "absolute",
                                      top: 10,
                                      left: 10,
                                    }}
                                  >
                                    <IconButton
                                      sx={{
                                        color: "#D32F2F", // color icon
                                        borderRadius: "50%",
                                        border: "2px solid #fff",
                                      }}
                                    >
                                      <Whatshot />
                                    </IconButton>
                                  </Badge>
                                </Card>
                              </Box>
                            );
                          })}
                        </Slider>
                      ) : (
                        <Grid container spacing={2}>
                          {recommendedProducts.map((product, index) => {
                            const { Product, car } = product;
                            return (
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={2.4}
                                key={index}
                              >
                                <Card
                                  className={classes.cardProducts}
                                  sx={{
                                    position: "relative",
                                  }}
                                >
                                  <CardMedia
                                    component="img"
                                    image={Product?.image || car?.image || ""}
                                    alt={Product?.product_name || car?.car_name}
                                    height={250}
                                    sx={{
                                      borderRadius: "22px",
                                      objectFit: "cover",
                                      p: "3px",
                                    }}
                                  />
                                  <CardContent
                                    sx={{
                                      width: "100%",
                                      padding: 1,
                                      height: "auto",
                                      "&:last-child": { paddingBottom: 1 },
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          width: "70%",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: "prompt",
                                            fontSize: "18px",
                                            fontWeight: "medium",
                                            color: "#212529",
                                          }}
                                          noWrap
                                        >
                                          {Product?.product_name ||
                                            car?.car_name}
                                        </Typography>
                                        <PriceFormatter
                                          price={
                                            Product?.price ||
                                            car?.sell_price ||
                                            car?.car_price ||
                                            0
                                          }
                                        />
                                      </Box>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "2px solid #ccc",
                                          borderRadius: "50%",
                                          height: "45px",
                                          width: "45px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setSelectedProduct(product);
                                          handleModal();
                                        }}
                                      >
                                        <NorthEast
                                          sx={{
                                            width: "20px",
                                            height: "20px",
                                            color: "#00bb9f",
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  </CardContent>
                                  <Badge
                                    sx={{
                                      position: "absolute",
                                      top: 10,
                                      left: 10,
                                    }}
                                  >
                                    <IconButton
                                      sx={{
                                        color: "#D32F2F", // color icon
                                        borderRadius: "50%",
                                        border: "2px solid #fff",
                                      }}
                                    >
                                      <Whatshot />
                                    </IconButton>
                                  </Badge>
                                </Card>
                              </Grid>
                            );
                          })}
                        </Grid>
                      )}
                    </Box>
                  </Box>
                )}

                {/* Latest Products */}
                {lastestProducts?.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      width: "100%",
                      mt: 2,
                      gap: 2,
                      padding: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography sx={{ fontSize: "32px" }}>
                        สินค้าล่าสุด
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => handleAllProduct("latest")}
                      >
                        <Typography
                          sx={{
                            fontWeight: "Regular",
                            fontSize: "20px",
                          }}
                        >
                          ดูทั้งหมด
                        </Typography>
                        <ChevronRight
                          sx={{
                            width: "24px",
                            height: "24px",
                          }}
                        />
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        padding: 1,
                        width: "100%",
                      }}
                    >
                      <Grid container spacing={2}>
                        {lastestProducts.slice(0, 5).map((product, index) => (
                          <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                            {renderProductCard(product, index)}
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </Box>
                )}

                {/* Other Products */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "100%",
                    mt: 2,
                    gap: 2,
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontSize: "32px" }}>อื่นๆ</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleAllProduct("all")}
                    >
                      <Typography
                        sx={{
                          fontWeight: "Regular",
                          fontSize: "20px",
                        }}
                      >
                        ดูทั้งหมด
                      </Typography>
                      <ChevronRight
                        sx={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>
                  {products?.length > 0 ? (
                    <>
                      <Box
                        sx={{
                          padding: 1,
                          width: "100%",
                        }}
                      >
                        <Grid container spacing={2}>
                          {products.map((product, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={2.4}
                              key={index}
                            >
                              {renderProductCard(product, index)}
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                      <CustomPagination
                        totalPage={paginate.totalPages}
                        page={paginate.page - 1}
                        rowsPerPage={paginate.limit}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                      />
                    </>
                  ) : (
                    <Box
                      sx={{
                        padding: 1,
                        width: "100%",
                        justifyContent: "center",
                      }}
                    >
                      <Typography variant="body1">
                        ไม่มีสินค้าใน Market Place
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
            <Contact />
          </Grid>
        </Grid>
      </Box>

      <ModalProduct
        open={openModal}
        product={selectedProduct}
        closeModal={handleModal}
      />
    </>
  );
}
export default MarketPlace;
